import { render, staticRenderFns } from "./CoverageList.vue?vue&type=template&id=697de60a&scoped=true&"
import script from "./CoverageList.vue?vue&type=script&lang=js&"
export * from "./CoverageList.vue?vue&type=script&lang=js&"
import style0 from "./CoverageList.vue?vue&type=style&index=0&id=697de60a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697de60a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VDataTable,VIcon})
